import RequestHandler from "./RequestHandler";

function AlertsAPI() {
    const baseModelsAPI = "alerts";

    async function getAlerts(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            let URL = `${baseModelsAPI}/scan/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function createAlert(body) {
        try {
            const result = await RequestHandler.post(
                `${baseModelsAPI}/scan`,
                body
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateAlert(body) {
        try {
            const result = await RequestHandler.put(
                `${baseModelsAPI}/scan`,
                body
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteAlerts(body) {
        try {
            const result = await RequestHandler.remove(
                `${baseModelsAPI}/delete-alerts`,
                body
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateAlertsStatus(body, alertStatus) {
        try {
            const result = await RequestHandler.put(
                `${baseModelsAPI}/update-alert-status?alertStatus=${alertStatus}`,
                body
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getAlertById(alertId) {
        try {
            const result = await RequestHandler.get(
                `${baseModelsAPI}/scan/${alertId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getAlerts,
        createAlert,
        updateAlert,
        deleteAlerts,
        updateAlertsStatus,
        getAlertById,
    };
}

export default AlertsAPI();
